import { z } from "zod";

export const PAYMENT_STATUSES = [
  "pending",
  "paid",
  "failed",
  "partially_refunded",
  "refunded",
  "cancelled",
] as const;

export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

export const PaymentIdParamSchema = z.object({
  id: z.string().min(1),
});

export const PaymentRecordRefundSchema = z.object({
  amount: z.coerce.number().int().min(1),
  note: z.string().max(2000).optional().nullable(),
  externalId: z.string().max(500).optional().nullable(),
  idempotencyKey: z.string().max(200).optional().nullable(),
});

export interface PaymentEventDTO {
  id: string;
  paymentId: string;
  eventType: string;
  payload: Record<string, unknown>;
  idempotencyKey: string | null;
  createdAt: string;
}

export interface PaymentDTO {
  id: string;
  orderId: string;
  orderCode?: string;
  externalId: string | null;
  amount: number;
  status: PaymentStatus;
  paidAt: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentRefundDTO {
  id: string;
  paymentId: string;
  orderId: string;
  amount: number;
  status: "pending" | "succeeded" | "failed";
  externalId: string | null;
  note: string | null;
  idempotencyKey: string | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentDetailDTO extends PaymentDTO {
  orderCode: string;
  events: PaymentEventDTO[];
  refunds: PaymentRefundDTO[];
  /** ยอดรวม succeeded ของ refunds รายนี้ */
  refundSucceededTotal: number;
  /** สลิปโอนที่แนบกับออเดอร์ (POS social / ช่องทางที่ใช้ payment_slip) */
  paymentSlips: Array<{ id: string; fileKey: string; sortOrder: number }>;
}

export interface PaymentSummaryDTO {
  total: number;
  totalPaid: number;
  byStatus: Record<string, number>;
}
